module.exports = __webpack_public_path__ + "img/18ad1ef.png";